export class GracieModel {
  orderId: number;
  value: string;

  constructor(orderId?: number, value?: string) {
    this.orderId = orderId;
    this.value = value;
  }
}
